import type {ReactElement} from 'react';
import type {AiChatQuickTipsItemProps} from './ai-chat-quick-tips-item.types';
import styles from './ai-chat-quick-tips-item.module.scss';
import {Text, TextSize} from '@Components/text';
import {StaticDot} from '@Components/static-dot/static-dot';
import {StaticDotSize, StaticDotTheme} from '@Components/static-dot/static-dot.types';
import {GA4EventName, trackGA4CustomEvent} from '@Libraries/ga-events';
import {AiChatQuickTipsCollapsibleCard} from '@AiChat/components/ai-chat-quick-tips/components/ai-chat-quick-tips-collapsible-card/ai-chat-quick-tips-collapsible-card';

export function AiChatQuickTipsItem({icon, title, bulletPoints, isSmall = false}: AiChatQuickTipsItemProps): ReactElement {
  const trackQuickTipExpand = (): void => {
    trackGA4CustomEvent(GA4EventName.AICHAT_QUICK_TIPS_EXPAND);
  };

  return (
    <AiChatQuickTipsCollapsibleCard icon={icon} title={title} onExpand={trackQuickTipExpand}>
      <div className={`flex-v-row ${isSmall ? 'gap-2' : 'gap-3'} ${styles.bulletList}`}>
        {bulletPoints.map((point, index) => (
          <div key={index} className={styles.bulletItem}>
            <StaticDot size={StaticDotSize.SIZE_4} theme={StaticDotTheme.PURPLE} />
            <Text size={TextSize.XSMALL} val={point} />
          </div>
        ))}
      </div>
    </AiChatQuickTipsCollapsibleCard>
  );
}
